import React from 'react'
import { MessageDescriptor, useIntl } from 'react-intl'
import { Placement } from '../popper'
import { IconButtonProps } from '@contrast-security-inc/design-system-buttons'
import { IconSize } from '@contrast-security-inc/design-system-foundations'
import {
  ActionButton,
  ActionButtonProps
} from '@contrast-security-inc/design-system-actions'

export interface ActionProps extends Pick<ActionButtonProps, 'isDisabled'> {
  icon: IconButtonProps['Icon']
  iconTooltipMessage: MessageDescriptor
  iconTooltipPlacement?: Placement
  size?: IconSize
  onClick?: () => void
  hideTooltip?: boolean
  innerRef?: React.Ref<HTMLElement>
  iconMetadata?: React.ReactNode
}

export function Action({
  icon: Icon,
  iconTooltipMessage,
  iconTooltipPlacement = 'auto',
  hideTooltip = false,
  iconMetadata,
  onClick,
  size = 'sm',
  ...props
}: ActionProps) {
  const { formatMessage } = useIntl()
  const tooltipMessage = formatMessage(iconTooltipMessage)

  return (
    <ActionButton
      {...props}
      onClick={onClick}
      metadata={iconMetadata}
      TooltipProps={{
        body: tooltipMessage,
        enabled: !hideTooltip,
        placement: iconTooltipPlacement
      }}
      IconButtonProps={{ size, Icon, 'aria-label': tooltipMessage }}
    ></ActionButton>
  )
}
